/**
 * ProviderHubView — Tier-1 of the Cloud GM AI Control Hub.
 *
 * Layout:
 *   - Centralized "AI Chat Archives" banner
 *   - Grid of provider cards (Anthropic / Google)
 *   - Refresh action at the bottom
 */
import { RefreshCw } from 'lucide-react';
import { ArchivesBanner } from './ArchivesBanner';
import { ProviderCard } from './ProviderCard';

export function ProviderHubView({ language, providers, onSelect, onRefresh, onOpenArchives }) {
  return (
    <>
      <ArchivesBanner language={language} onClick={onOpenArchives} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="ai-provider-hub">
        {providers.map((p) => (
          <ProviderCard key={p.provider} provider={p} language={language} onSelect={onSelect} />
        ))}
      </div>

      <div className="flex justify-end pt-2">
        <button
          onClick={onRefresh}
          className="px-3 py-2 text-xs rounded-lg bg-white/5 border border-white/10 text-[#A1A1AA] hover:text-white flex items-center gap-2"
          data-testid="ai-providers-refresh"
        >
          <RefreshCw className="h-3.5 w-3.5" />
          {language === 'ar' ? 'تحديث' : 'Refresh'}
        </button>
      </div>
    </>
  );
}
